import React from 'react';
import HomeScreen from './screens/Home';

import { Header, Footer } from './components';

function App() {
  return (
    <div>
      <Header />
      <HomeScreen />
      <Footer />
    </div>
  );
}

export default App;
